// agent-memory-form.presentation.tsx
export const AGENT_MEMORY_LABEL_TEXT = {
    id: 'oe.control.agentMemory',
    defaultMessage: 'Agent Memory',
    description: 'Label text',
};

export const AGENT_MEMORY_IS_BEING_SAVED_TEXT = {
    id: 'oe.control.agentMemoryIsBeingSaved',
    description: 'Placeholder about saving agent memory',
    defaultMessage: 'Agent Memory is being saved, please wait...',
};

// agent-memory-form.viewmodel.ts
export const AGENT_MEMORY_LAST_MODIFIED_TEXT = {
    id: 'oe.control.agentMemoryLastModified',
    defaultMessage: 'Last modified by {user} at {dateTime}',
    description: 'Agent Memory last modification info',
};

// manage-event.viewmodel.ts
export const EDIT_AGENT_MEMORY_POPUP_TITLE_TEXT = {
    id: 'oe.control.editAgentMemory',
    defaultMessage: 'Edit Agent Memory',
    description: 'Edit event Agent Memory',
};

// meetings-list.presentation.tsx
export const EDIT_AGENT_MEMORY_MENU_ITEM_TEXT = {
    id: 'oe.meetings.editAgentMemory',
    defaultMessage: 'Edit Agent Memory',
    description: 'Edit event Agent Memory',
};
